var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproleAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/AWS/Role") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/AWS/Role",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F6FBFF",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    transform: "translate(23.244, 22.9998)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amazon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90033683,2.62566989 C4.90033683,1.8361612 5.00219376,1.23549107 4.2049646,1.23750012 C4.2049646,1.23750012 3.46258173,1.23750012 3.14329822,2.23191977 L1.70358451,2.09531225 C1.70358451,1.10491071 2.61834133,0 4.34208019,0 C6.06190153,0 6.5418061,1.14508929 6.5418061,1.65334797 L6.5418061,4.60848202 C6.5418061,5.16093738 7.17449637,5.66919667 7.17449637,5.66919667 L6.06190153,6.79419667 C5.86798102,6.60736656 5.30188963,6.05892931 5.17456801,5.85401835 C4.28919311,7.27633953 1.58018072,7.18593775 1.58018072,4.98616096 C1.58018072,2.93705382 3.94640413,2.66183036 4.90033683,2.62566989 Z M4.90033683,3.55379483 C4.24022325,3.57589316 3.2510322,3.76674138 3.2510322,4.7149556 C3.2510322,5.73549107 4.90033683,5.9765625 4.90033683,4.36941964 L4.90033683,3.55379483 Z",
    id: "Shape",
    fill: "#232F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.160054653,6.80424132 C1.59585083,7.69821453 3.83867015,9.17075893 7.45656321,7.41294643 C7.60347277,7.33861583 7.71708259,7.453125 7.56429689,7.65401786 C7.4134695,7.85491071 6.19314097,9 4.14620107,9 C2.09926117,9 0.532225544,7.56361607 0.0523209736,6.97098214 C-0.0808770893,6.8162944 0.0719089152,6.74397346 0.160054653,6.80424132 Z M8.47121835,6.83236681 C8.54369397,6.93482229 8.47121835,7.37678657 8.34389673,7.69821514 C8.2165751,8.015625 8.03048966,8.23660714 7.92863212,8.32098239 C7.82089844,8.41138417 7.74254668,8.3752237 7.8013105,8.24464335 C7.86007433,8.11406299 8.17935754,7.31049156 8.0500776,7.13973263 C7.92275598,6.97299181 7.32532376,7.05334895 7.1098564,7.07544667 C6.89830687,7.09553596 6.85521316,7.11562525 6.83562522,7.06942013 C6.79057319,6.95491096 7.26068379,6.7580362 7.57017303,6.71785763 C7.87770395,6.68169716 8.37327864,6.70178645 8.47121835,6.83236681 Z",
    id: "Path-2",
    fill: "#FF9900"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uF807",
    transform: "translate(9.1249, 10.125)",
    fill: "#2E3955"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8750714,6.80585921 C14.8750714,4.36761665 13.1844064,2.28320312 11.0578833,1.40820312 L9.62507096,3.88828158 L9.62507096,0.486171842 C9.62507096,0.216289163 9.4090555,0 9.13835254,0 L6.61178979,0 C6.34108642,0 6.12507096,0.216289163 6.12507096,0.486171842 L6.12507096,3.88773417 L4.69225862,1.4090234 C2.56573507,2.28320312 0.875070957,4.36679721 0.875070957,6.80585921 L0.87479767,8.75 L14.8747977,8.75 L14.8750714,6.80585921 L14.8750714,6.80585921 Z M15.7145248,9.89023471 C15.6461655,9.72890592 15.487572,9.625 15.3125714,9.625 L0.437571374,9.625 C0.263254968,9.625 0.105071274,9.7292347 0.03589162,9.88903141 C-0.0333155714,10.0496759 -0.000858636971,10.2360237 0.119618086,10.3631719 C0.192325024,10.4398434 1.96936795,12.25 7.85046217,12.25 C13.7315564,12.25 15.5094467,10.4401171 15.6051498,10.3632812 C15.7500714,10.2347653 15.7828842,10.0488281 15.7145248,9.89023471 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproleAws);
export default __webpack_public_path__ + "static/media/approle_aws.a217edc2b18e02e11a7aecc8d424ac59.svg";
export { ForwardRef as ReactComponent };